
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { Form as ElForm } from 'element-ui'
import { getConst } from '@/api/universal'
import { getProductList } from '@/api/product/product'
import {
  getAgentProductInfo,
  setAgentProduct,
  addAgentProduct
} from '@/api/merchant/agentProduct'
import { merchantAgentProductRules } from '@/utils/rules'
import { delObjEmptyKey } from '@/utils'

@Component({
  name: 'editAgentProduct',
  components: {}
})
export default class extends Vue {
  @Prop({ required: true }) merchant_no!: string
  @Prop({ default: '' }) agentProductId!: string
  @Prop({ default: [] }) productNameList!: string[]

  private infoForm: any = {
    currency: '',
    product: null,
    product_type: '',
    product_name: '',
    min_fee: '',
    fixed_fee: '0',
    rate: '',
    extra_param: {
      product_small_fee_list: [
        {
          fixed_fee: '',
          rate: '',
          min_amount: '',
          max_amount: ''
        }
      ]
    }
  }

  private rules = merchantAgentProductRules
  private agentProductInfo: any = {}
  private currencyTypes: any[] =
    this.$store.state.app.enterprise.available_currency
  private productList: any[] = []
  private currentProductIndex: any = null
  private productTypes: any[] = []
  private loading = false

  private addFeeItem() {
    this.infoForm.extra_param.product_small_fee_list.push({
      min_amount: '',
      max_amount: '',
      fixed_fee: '',
      rate: ''
    })
  }

  private removeFeeItem(index) {
    this.infoForm.extra_param.product_small_fee_list.splice(index, 1)
  }

  // 监听
  @Watch('infoForm.currency')
  private onCurrencyChange() {
    if (this.infoForm.product_type && this.infoForm.currency) {
      this.getProductList()
    }
  }

  @Watch('infoForm.product_type')
  private onProuctTypeChange() {
    this.currentProductIndex = ''
    if (this.infoForm.product_type && this.infoForm.currency) {
      this.getProductList()
    }
  }

  // 获取产品列表
  private async getProductList() {
    this.productList = []
    const data = {
      currency: this.infoForm.currency,
      product_type: this.infoForm.product_type
    }
    await getProductList(data).then((res: any) => {
      this.productList = res.filter((item: any) => {
        return !this.productNameList.includes(item.name)
      })
    })
  }

  // 选择产品
  private async selProductName(index: number) {
    const product = this.productList[index]

    this.infoForm.product_name = product.name
    this.infoForm.product = product.id
    this.infoForm.product_account = []
  }

  private flag: boolean = false
  // 按钮只触发一次
  private flagStr() {
    setTimeout(() => {
      this.flag = false
    }, 500)
  }

  private back() {
    this.$emit('close')
  }

  private save() {
    ;(this.$refs.productForm as ElForm).validate(async (valid: boolean) => {
      if (valid) {
        try {
          this.loading = true
          this.flag = true
          const data: any = {
            merchant_no: this.merchant_no,
            ...this.infoForm
          }

          delObjEmptyKey(data)
          if (!this.agentProductId) {
            console.log(data)
            await addAgentProduct(data).then((res: any) => {
              this.$message({
                message: 'Create successful!',
                type: 'success'
              })
              this.loading = false
              this.flagStr()
              this.back()
            })
          } else {
            await setAgentProduct(data).then((res: any) => {
              this.$message({
                message: 'Save successful!',
                type: 'success'
              })
              this.loading = false
              this.flagStr()
              this.back()
            })
          }
        } catch (e) {
          this.loading = false
          this.flagStr()
        }
      } else {
        return false
      }
    })
  }

  // 获取产品类型列表
  private async getProductTypes() {
    await getConst('PRODUCT_TYPE_CHOICES').then((res: any) => {
      this.productTypes = res.data
    })
  }

  // 获取商户代理产品信息
  private async getAgentProductInfo() {
    try {
      const data: any = {
        merchant_no: this.merchant_no,
        id: this.agentProductId
      }
      await getAgentProductInfo(data).then((res: any) => {
        this.agentProductInfo = res
        this.agentProductInfo.product_type =
          this.agentProductInfo.product_type.toLowerCase()
        console.log(res)

        if (!res.extra_param && res.product_type !== 'settlement') {
          // this.infoForm = { ...this.agentProductInfo }
          this.infoForm = {
            currency: res.currency,
            product: res.product,
            product_type: res.product_type,
            product_name: res.product_name,
            min_fee: res.min_fee,
            fixed_fee: res.fixed_fee,
            rate: res.rate,
            extra_param: {
              product_small_fee_list: [
                {
                  fixed_fee: '0',
                  rate: '0',
                  min_amount: '0',
                  max_amount: '0'
                }
              ]
            }
          }
        } else if (res.extra_param) {
          this.infoForm = { ...res, ...res.extra_param }
        } else {
          this.infoForm = { ...res }
        }
      })
    } catch (e) {}
  }

  private init() {
    this.currentProductIndex = null
    this.infoForm = {}
  }
  destroy() {
    this.init()
  }
  mounted() {
    if (this.agentProductId) {
      this.getAgentProductInfo()
    }
    this.getProductTypes()
    this.getProductList()
  }
}
